<!-- <div>TOTO{{value}}</div> -->
<div class="flex items-center gap-[8px] mb-[10px] last:mb-0">
    <input 
        type="checkbox"
        class="cursor-pointer w-4 h-4 accent-primary-500"
        [checked]="value" 
        (input)="onInput($event)"
        (blur)="onTouched()"
        [disabled]="disabled || corpLoading"
        [readonly]="corpReadonly"
        
        id="defaultCheckbox">
    <label for="defaultCheckbox" class="cursor-pointer">
        {{ corpLabel }}
    </label>
</div>